import { useMutation, useQueryClient } from "@tanstack/react-query";
import { selectShippingMethod } from "../../services/checkoutApi";

export const useSelectMethod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ shipmentId, optionId }) =>
      selectShippingMethod({ shipmentId, optionId }),

    onMutate: async ({ shipmentId, optionId }) => {
      await queryClient.cancelQueries({ queryKey: ["checkout"] });

      const previousCheckoutData = queryClient.getQueryData(["checkout"]);

      queryClient.setQueryData(["checkout"], (oldData) => {
        if (!oldData) return oldData;

        return {
          ...oldData,
          shipments: oldData.shipments.map((shipment) => {
            if (shipment.id !== shipmentId) return shipment;

            const selectedOption =
              shipment.options.find((opt) => opt.id === optionId) ||
              shipment.selected_option;

            return {
              ...shipment,
              selected_option: selectedOption,
            };
          }),
        };
      });

      return { previousCheckoutData };
    },

    onError: (err, _variables, context) => {
      if (context?.previousCheckoutData) {
        queryClient.setQueryData(["checkout"], context.previousCheckoutData);
      }
      console.error("خطا در انتخاب روش ارسال:", err);
    },

    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ["checkout"] });
    },
  });
};
